import type { PropsWithChildren } from "react";
import { useEffect, useState } from "react";

import { LoadingPage } from "@/components/LoadingPage";
import { useServiceContext } from "@/services";

import { useCurrentMondayContext } from "./WithMondayContextAvailable";

// This component is responsible for ensuring that the CLI backend has stored an OAuth token
// If so, it will display the child components (our app content) else it will trigger the OAuth flow.
export function WithOAuthEnabled({ children }: PropsWithChildren) {
  const { monday, oauth } = useServiceContext();
  const [isLoading, setIsLoading] = useState(true);

  const {
    app: { clientId },
  } = useCurrentMondayContext();

  useEffect(() => {
    Promise.all([monday.fetchSessionToken(), monday.fetchAccountSlug()])
      .then(([token, slug]) => {
        return oauth.ensureToken(clientId, token, slug);
      })
      .then((hasToken) => {
        if (hasToken) {
          setIsLoading(false);
        }
      })
      .catch((e) => {
        // TODO: proper error handling
        console.error(e);
      });
  }, [monday, oauth, clientId]);

  if (isLoading) {
    // TODO: this is duplicated with the loading page in the parent context, and should be unified when the overall
    //       context component structure is refactored; we should instead be using use/Suspense at the parent level
    //       (i.e., with a custom usePromise substituted for use until React 18.3)
    return <LoadingPage label="Loading…" />;
  }

  return <>{children}</>;
}
